// source: storage.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var general_pb = require('./general_pb.js');
goog.object.extend(proto, general_pb);
goog.exportSymbol('proto.cloud.BucketObject', null, global);
goog.exportSymbol('proto.cloud.CancelMultiPartUpload', null, global);
goog.exportSymbol('proto.cloud.CompleteMultiPartUpload', null, global);
goog.exportSymbol('proto.cloud.CompleteMultiPartUpload.Part', null, global);
goog.exportSymbol('proto.cloud.SignedDownload', null, global);
goog.exportSymbol('proto.cloud.SignedMultiPartUpload', null, global);
goog.exportSymbol('proto.cloud.SignedMultiPartUpload.Part', null, global);
goog.exportSymbol('proto.cloud.SignedPostPolicy', null, global);
goog.exportSymbol('proto.cloud.SignedPutUpload', null, global);
goog.exportSymbol('proto.cloud.UploadData', null, global);
goog.exportSymbol('proto.cloud.UploadResult', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.BucketObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.BucketObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.BucketObject.displayName = 'proto.cloud.BucketObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.SignedDownload = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.SignedDownload, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.SignedDownload.displayName = 'proto.cloud.SignedDownload';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.SignedPutUpload = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.SignedPutUpload, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.SignedPutUpload.displayName = 'proto.cloud.SignedPutUpload';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.SignedMultiPartUpload = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.SignedMultiPartUpload.repeatedFields_, null);
};
goog.inherits(proto.cloud.SignedMultiPartUpload, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.SignedMultiPartUpload.displayName = 'proto.cloud.SignedMultiPartUpload';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.SignedMultiPartUpload.Part = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.SignedMultiPartUpload.Part, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.SignedMultiPartUpload.Part.displayName = 'proto.cloud.SignedMultiPartUpload.Part';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.CompleteMultiPartUpload = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.CompleteMultiPartUpload.repeatedFields_, null);
};
goog.inherits(proto.cloud.CompleteMultiPartUpload, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.CompleteMultiPartUpload.displayName = 'proto.cloud.CompleteMultiPartUpload';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.CompleteMultiPartUpload.Part = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.CompleteMultiPartUpload.Part, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.CompleteMultiPartUpload.Part.displayName = 'proto.cloud.CompleteMultiPartUpload.Part';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.CancelMultiPartUpload = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.CancelMultiPartUpload, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.CancelMultiPartUpload.displayName = 'proto.cloud.CancelMultiPartUpload';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.SignedPostPolicy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.SignedPostPolicy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.SignedPostPolicy.displayName = 'proto.cloud.SignedPostPolicy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.UploadData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.UploadData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.UploadData.displayName = 'proto.cloud.UploadData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.UploadResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.UploadResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.UploadResult.displayName = 'proto.cloud.UploadResult';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.BucketObject.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.BucketObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.BucketObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BucketObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    size: jspb.Message.getFieldWithDefault(msg, 2, 0),
    dateCreated: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.BucketObject}
 */
proto.cloud.BucketObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.BucketObject;
  return proto.cloud.BucketObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.BucketObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.BucketObject}
 */
proto.cloud.BucketObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateCreated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.BucketObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.BucketObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.BucketObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.BucketObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDateCreated();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.cloud.BucketObject.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BucketObject} returns this
 */
proto.cloud.BucketObject.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 size = 2;
 * @return {number}
 */
proto.cloud.BucketObject.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.BucketObject} returns this
 */
proto.cloud.BucketObject.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string date_created = 3;
 * @return {string}
 */
proto.cloud.BucketObject.prototype.getDateCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.BucketObject} returns this
 */
proto.cloud.BucketObject.prototype.setDateCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.SignedDownload.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.SignedDownload.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.SignedDownload} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.SignedDownload.toObject = function(includeInstance, msg) {
  var f, obj = {
    signedUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    objectPath: jspb.Message.getFieldWithDefault(msg, 2, ""),
    filename: jspb.Message.getFieldWithDefault(msg, 3, ""),
    expectedSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
    mimeType: jspb.Message.getFieldWithDefault(msg, 5, ""),
    expireDate: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.SignedDownload}
 */
proto.cloud.SignedDownload.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.SignedDownload;
  return proto.cloud.SignedDownload.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.SignedDownload} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.SignedDownload}
 */
proto.cloud.SignedDownload.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignedUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectPath(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpectedSize(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpireDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.SignedDownload.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.SignedDownload.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.SignedDownload} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.SignedDownload.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSignedUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getObjectPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExpectedSize();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getExpireDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string signed_url = 1;
 * @return {string}
 */
proto.cloud.SignedDownload.prototype.getSignedUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedDownload} returns this
 */
proto.cloud.SignedDownload.prototype.setSignedUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string object_path = 2;
 * @return {string}
 */
proto.cloud.SignedDownload.prototype.getObjectPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedDownload} returns this
 */
proto.cloud.SignedDownload.prototype.setObjectPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string filename = 3;
 * @return {string}
 */
proto.cloud.SignedDownload.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedDownload} returns this
 */
proto.cloud.SignedDownload.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 expected_size = 4;
 * @return {number}
 */
proto.cloud.SignedDownload.prototype.getExpectedSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.SignedDownload} returns this
 */
proto.cloud.SignedDownload.prototype.setExpectedSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string mime_type = 5;
 * @return {string}
 */
proto.cloud.SignedDownload.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedDownload} returns this
 */
proto.cloud.SignedDownload.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string expire_date = 6;
 * @return {string}
 */
proto.cloud.SignedDownload.prototype.getExpireDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedDownload} returns this
 */
proto.cloud.SignedDownload.prototype.setExpireDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.SignedPutUpload.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.SignedPutUpload.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.SignedPutUpload} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.SignedPutUpload.toObject = function(includeInstance, msg) {
  var f, obj = {
    signedUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    objectPath: jspb.Message.getFieldWithDefault(msg, 2, ""),
    expireDate: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.SignedPutUpload}
 */
proto.cloud.SignedPutUpload.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.SignedPutUpload;
  return proto.cloud.SignedPutUpload.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.SignedPutUpload} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.SignedPutUpload}
 */
proto.cloud.SignedPutUpload.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignedUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectPath(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpireDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.SignedPutUpload.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.SignedPutUpload.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.SignedPutUpload} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.SignedPutUpload.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSignedUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getObjectPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExpireDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string signed_url = 1;
 * @return {string}
 */
proto.cloud.SignedPutUpload.prototype.getSignedUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedPutUpload} returns this
 */
proto.cloud.SignedPutUpload.prototype.setSignedUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string object_path = 2;
 * @return {string}
 */
proto.cloud.SignedPutUpload.prototype.getObjectPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedPutUpload} returns this
 */
proto.cloud.SignedPutUpload.prototype.setObjectPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string expire_date = 3;
 * @return {string}
 */
proto.cloud.SignedPutUpload.prototype.getExpireDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedPutUpload} returns this
 */
proto.cloud.SignedPutUpload.prototype.setExpireDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.SignedMultiPartUpload.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.SignedMultiPartUpload.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.SignedMultiPartUpload.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.SignedMultiPartUpload} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.SignedMultiPartUpload.toObject = function(includeInstance, msg) {
  var f, obj = {
    objectPath: jspb.Message.getFieldWithDefault(msg, 1, ""),
    uploadPartsList: jspb.Message.toObjectList(msg.getUploadPartsList(),
    proto.cloud.SignedMultiPartUpload.Part.toObject, includeInstance),
    expireDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    uploadId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.SignedMultiPartUpload}
 */
proto.cloud.SignedMultiPartUpload.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.SignedMultiPartUpload;
  return proto.cloud.SignedMultiPartUpload.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.SignedMultiPartUpload} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.SignedMultiPartUpload}
 */
proto.cloud.SignedMultiPartUpload.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectPath(value);
      break;
    case 2:
      var value = new proto.cloud.SignedMultiPartUpload.Part;
      reader.readMessage(value,proto.cloud.SignedMultiPartUpload.Part.deserializeBinaryFromReader);
      msg.addUploadParts(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpireDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.SignedMultiPartUpload.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.SignedMultiPartUpload.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.SignedMultiPartUpload} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.SignedMultiPartUpload.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObjectPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUploadPartsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.cloud.SignedMultiPartUpload.Part.serializeBinaryToWriter
    );
  }
  f = message.getExpireDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUploadId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.SignedMultiPartUpload.Part.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.SignedMultiPartUpload.Part.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.SignedMultiPartUpload.Part} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.SignedMultiPartUpload.Part.toObject = function(includeInstance, msg) {
  var f, obj = {
    signedUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    expectedSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    partNumber: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.SignedMultiPartUpload.Part}
 */
proto.cloud.SignedMultiPartUpload.Part.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.SignedMultiPartUpload.Part;
  return proto.cloud.SignedMultiPartUpload.Part.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.SignedMultiPartUpload.Part} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.SignedMultiPartUpload.Part}
 */
proto.cloud.SignedMultiPartUpload.Part.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignedUrl(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpectedSize(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPartNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.SignedMultiPartUpload.Part.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.SignedMultiPartUpload.Part.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.SignedMultiPartUpload.Part} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.SignedMultiPartUpload.Part.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSignedUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpectedSize();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPartNumber();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string signed_url = 1;
 * @return {string}
 */
proto.cloud.SignedMultiPartUpload.Part.prototype.getSignedUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedMultiPartUpload.Part} returns this
 */
proto.cloud.SignedMultiPartUpload.Part.prototype.setSignedUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 expected_size = 2;
 * @return {number}
 */
proto.cloud.SignedMultiPartUpload.Part.prototype.getExpectedSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.SignedMultiPartUpload.Part} returns this
 */
proto.cloud.SignedMultiPartUpload.Part.prototype.setExpectedSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 part_number = 3;
 * @return {number}
 */
proto.cloud.SignedMultiPartUpload.Part.prototype.getPartNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.SignedMultiPartUpload.Part} returns this
 */
proto.cloud.SignedMultiPartUpload.Part.prototype.setPartNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string object_path = 1;
 * @return {string}
 */
proto.cloud.SignedMultiPartUpload.prototype.getObjectPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedMultiPartUpload} returns this
 */
proto.cloud.SignedMultiPartUpload.prototype.setObjectPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Part upload_parts = 2;
 * @return {!Array<!proto.cloud.SignedMultiPartUpload.Part>}
 */
proto.cloud.SignedMultiPartUpload.prototype.getUploadPartsList = function() {
  return /** @type{!Array<!proto.cloud.SignedMultiPartUpload.Part>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.SignedMultiPartUpload.Part, 2));
};


/**
 * @param {!Array<!proto.cloud.SignedMultiPartUpload.Part>} value
 * @return {!proto.cloud.SignedMultiPartUpload} returns this
*/
proto.cloud.SignedMultiPartUpload.prototype.setUploadPartsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.cloud.SignedMultiPartUpload.Part=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.SignedMultiPartUpload.Part}
 */
proto.cloud.SignedMultiPartUpload.prototype.addUploadParts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.cloud.SignedMultiPartUpload.Part, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.SignedMultiPartUpload} returns this
 */
proto.cloud.SignedMultiPartUpload.prototype.clearUploadPartsList = function() {
  return this.setUploadPartsList([]);
};


/**
 * optional string expire_date = 3;
 * @return {string}
 */
proto.cloud.SignedMultiPartUpload.prototype.getExpireDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedMultiPartUpload} returns this
 */
proto.cloud.SignedMultiPartUpload.prototype.setExpireDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string upload_id = 5;
 * @return {string}
 */
proto.cloud.SignedMultiPartUpload.prototype.getUploadId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedMultiPartUpload} returns this
 */
proto.cloud.SignedMultiPartUpload.prototype.setUploadId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.CompleteMultiPartUpload.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.CompleteMultiPartUpload.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.CompleteMultiPartUpload.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.CompleteMultiPartUpload} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.CompleteMultiPartUpload.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    partsList: jspb.Message.toObjectList(msg.getPartsList(),
    proto.cloud.CompleteMultiPartUpload.Part.toObject, includeInstance),
    uploadId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.CompleteMultiPartUpload}
 */
proto.cloud.CompleteMultiPartUpload.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.CompleteMultiPartUpload;
  return proto.cloud.CompleteMultiPartUpload.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.CompleteMultiPartUpload} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.CompleteMultiPartUpload}
 */
proto.cloud.CompleteMultiPartUpload.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = new proto.cloud.CompleteMultiPartUpload.Part;
      reader.readMessage(value,proto.cloud.CompleteMultiPartUpload.Part.deserializeBinaryFromReader);
      msg.addParts(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.CompleteMultiPartUpload.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.CompleteMultiPartUpload.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.CompleteMultiPartUpload} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.CompleteMultiPartUpload.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPartsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.cloud.CompleteMultiPartUpload.Part.serializeBinaryToWriter
    );
  }
  f = message.getUploadId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.CompleteMultiPartUpload.Part.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.CompleteMultiPartUpload.Part.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.CompleteMultiPartUpload.Part} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.CompleteMultiPartUpload.Part.toObject = function(includeInstance, msg) {
  var f, obj = {
    partNumber: jspb.Message.getFieldWithDefault(msg, 1, 0),
    eTag: jspb.Message.getFieldWithDefault(msg, 2, ""),
    checksum: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.CompleteMultiPartUpload.Part}
 */
proto.cloud.CompleteMultiPartUpload.Part.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.CompleteMultiPartUpload.Part;
  return proto.cloud.CompleteMultiPartUpload.Part.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.CompleteMultiPartUpload.Part} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.CompleteMultiPartUpload.Part}
 */
proto.cloud.CompleteMultiPartUpload.Part.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPartNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setETag(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChecksum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.CompleteMultiPartUpload.Part.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.CompleteMultiPartUpload.Part.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.CompleteMultiPartUpload.Part} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.CompleteMultiPartUpload.Part.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPartNumber();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getETag();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChecksum();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 part_number = 1;
 * @return {number}
 */
proto.cloud.CompleteMultiPartUpload.Part.prototype.getPartNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.CompleteMultiPartUpload.Part} returns this
 */
proto.cloud.CompleteMultiPartUpload.Part.prototype.setPartNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string e_tag = 2;
 * @return {string}
 */
proto.cloud.CompleteMultiPartUpload.Part.prototype.getETag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.CompleteMultiPartUpload.Part} returns this
 */
proto.cloud.CompleteMultiPartUpload.Part.prototype.setETag = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string checksum = 3;
 * @return {string}
 */
proto.cloud.CompleteMultiPartUpload.Part.prototype.getChecksum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.CompleteMultiPartUpload.Part} returns this
 */
proto.cloud.CompleteMultiPartUpload.Part.prototype.setChecksum = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.cloud.CompleteMultiPartUpload.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.CompleteMultiPartUpload} returns this
 */
proto.cloud.CompleteMultiPartUpload.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Part parts = 2;
 * @return {!Array<!proto.cloud.CompleteMultiPartUpload.Part>}
 */
proto.cloud.CompleteMultiPartUpload.prototype.getPartsList = function() {
  return /** @type{!Array<!proto.cloud.CompleteMultiPartUpload.Part>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.CompleteMultiPartUpload.Part, 2));
};


/**
 * @param {!Array<!proto.cloud.CompleteMultiPartUpload.Part>} value
 * @return {!proto.cloud.CompleteMultiPartUpload} returns this
*/
proto.cloud.CompleteMultiPartUpload.prototype.setPartsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.cloud.CompleteMultiPartUpload.Part=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.CompleteMultiPartUpload.Part}
 */
proto.cloud.CompleteMultiPartUpload.prototype.addParts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.cloud.CompleteMultiPartUpload.Part, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.CompleteMultiPartUpload} returns this
 */
proto.cloud.CompleteMultiPartUpload.prototype.clearPartsList = function() {
  return this.setPartsList([]);
};


/**
 * optional string upload_id = 3;
 * @return {string}
 */
proto.cloud.CompleteMultiPartUpload.prototype.getUploadId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.CompleteMultiPartUpload} returns this
 */
proto.cloud.CompleteMultiPartUpload.prototype.setUploadId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.CancelMultiPartUpload.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.CancelMultiPartUpload.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.CancelMultiPartUpload} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.CancelMultiPartUpload.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    uploadId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.CancelMultiPartUpload}
 */
proto.cloud.CancelMultiPartUpload.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.CancelMultiPartUpload;
  return proto.cloud.CancelMultiPartUpload.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.CancelMultiPartUpload} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.CancelMultiPartUpload}
 */
proto.cloud.CancelMultiPartUpload.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.CancelMultiPartUpload.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.CancelMultiPartUpload.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.CancelMultiPartUpload} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.CancelMultiPartUpload.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUploadId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.cloud.CancelMultiPartUpload.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.CancelMultiPartUpload} returns this
 */
proto.cloud.CancelMultiPartUpload.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string upload_id = 2;
 * @return {string}
 */
proto.cloud.CancelMultiPartUpload.prototype.getUploadId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.CancelMultiPartUpload} returns this
 */
proto.cloud.CancelMultiPartUpload.prototype.setUploadId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.SignedPostPolicy.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.SignedPostPolicy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.SignedPostPolicy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.SignedPostPolicy.toObject = function(includeInstance, msg) {
  var f, obj = {
    uploadUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    postPolicyMap: (f = msg.getPostPolicyMap()) ? f.toObject(includeInstance, undefined) : [],
    objectPath: jspb.Message.getFieldWithDefault(msg, 3, ""),
    expireDate: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.SignedPostPolicy}
 */
proto.cloud.SignedPostPolicy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.SignedPostPolicy;
  return proto.cloud.SignedPostPolicy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.SignedPostPolicy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.SignedPostPolicy}
 */
proto.cloud.SignedPostPolicy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadUrl(value);
      break;
    case 2:
      var value = msg.getPostPolicyMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectPath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpireDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.SignedPostPolicy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.SignedPostPolicy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.SignedPostPolicy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.SignedPostPolicy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUploadUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPostPolicyMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getObjectPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExpireDate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string upload_url = 1;
 * @return {string}
 */
proto.cloud.SignedPostPolicy.prototype.getUploadUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedPostPolicy} returns this
 */
proto.cloud.SignedPostPolicy.prototype.setUploadUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * map<string, string> post_policy = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.cloud.SignedPostPolicy.prototype.getPostPolicyMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.cloud.SignedPostPolicy} returns this
 */
proto.cloud.SignedPostPolicy.prototype.clearPostPolicyMap = function() {
  this.getPostPolicyMap().clear();
  return this;};


/**
 * optional string object_path = 3;
 * @return {string}
 */
proto.cloud.SignedPostPolicy.prototype.getObjectPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedPostPolicy} returns this
 */
proto.cloud.SignedPostPolicy.prototype.setObjectPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string expire_date = 4;
 * @return {string}
 */
proto.cloud.SignedPostPolicy.prototype.getExpireDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.SignedPostPolicy} returns this
 */
proto.cloud.SignedPostPolicy.prototype.setExpireDate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.UploadData.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.UploadData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.UploadData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UploadData.toObject = function(includeInstance, msg) {
  var f, obj = {
    entity: (f = msg.getEntity()) && general_pb.EntityId.toObject(includeInstance, f),
    singlePartUpload: (f = msg.getSinglePartUpload()) && proto.cloud.SignedPutUpload.toObject(includeInstance, f),
    multiPartUpload: (f = msg.getMultiPartUpload()) && proto.cloud.SignedMultiPartUpload.toObject(includeInstance, f),
    entityAlreadyExists: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    storageLocation: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.UploadData}
 */
proto.cloud.UploadData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.UploadData;
  return proto.cloud.UploadData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.UploadData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.UploadData}
 */
proto.cloud.UploadData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new general_pb.EntityId;
      reader.readMessage(value,general_pb.EntityId.deserializeBinaryFromReader);
      msg.setEntity(value);
      break;
    case 2:
      var value = new proto.cloud.SignedPutUpload;
      reader.readMessage(value,proto.cloud.SignedPutUpload.deserializeBinaryFromReader);
      msg.setSinglePartUpload(value);
      break;
    case 3:
      var value = new proto.cloud.SignedMultiPartUpload;
      reader.readMessage(value,proto.cloud.SignedMultiPartUpload.deserializeBinaryFromReader);
      msg.setMultiPartUpload(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEntityAlreadyExists(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStorageLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.UploadData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.UploadData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.UploadData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UploadData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      general_pb.EntityId.serializeBinaryToWriter
    );
  }
  f = message.getSinglePartUpload();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.cloud.SignedPutUpload.serializeBinaryToWriter
    );
  }
  f = message.getMultiPartUpload();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.cloud.SignedMultiPartUpload.serializeBinaryToWriter
    );
  }
  f = message.getEntityAlreadyExists();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getStorageLocation();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional EntityId entity = 1;
 * @return {?proto.cloud.EntityId}
 */
proto.cloud.UploadData.prototype.getEntity = function() {
  return /** @type{?proto.cloud.EntityId} */ (
    jspb.Message.getWrapperField(this, general_pb.EntityId, 1));
};


/**
 * @param {?proto.cloud.EntityId|undefined} value
 * @return {!proto.cloud.UploadData} returns this
*/
proto.cloud.UploadData.prototype.setEntity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.UploadData} returns this
 */
proto.cloud.UploadData.prototype.clearEntity = function() {
  return this.setEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.UploadData.prototype.hasEntity = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SignedPutUpload single_part_upload = 2;
 * @return {?proto.cloud.SignedPutUpload}
 */
proto.cloud.UploadData.prototype.getSinglePartUpload = function() {
  return /** @type{?proto.cloud.SignedPutUpload} */ (
    jspb.Message.getWrapperField(this, proto.cloud.SignedPutUpload, 2));
};


/**
 * @param {?proto.cloud.SignedPutUpload|undefined} value
 * @return {!proto.cloud.UploadData} returns this
*/
proto.cloud.UploadData.prototype.setSinglePartUpload = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.UploadData} returns this
 */
proto.cloud.UploadData.prototype.clearSinglePartUpload = function() {
  return this.setSinglePartUpload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.UploadData.prototype.hasSinglePartUpload = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SignedMultiPartUpload multi_part_upload = 3;
 * @return {?proto.cloud.SignedMultiPartUpload}
 */
proto.cloud.UploadData.prototype.getMultiPartUpload = function() {
  return /** @type{?proto.cloud.SignedMultiPartUpload} */ (
    jspb.Message.getWrapperField(this, proto.cloud.SignedMultiPartUpload, 3));
};


/**
 * @param {?proto.cloud.SignedMultiPartUpload|undefined} value
 * @return {!proto.cloud.UploadData} returns this
*/
proto.cloud.UploadData.prototype.setMultiPartUpload = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.UploadData} returns this
 */
proto.cloud.UploadData.prototype.clearMultiPartUpload = function() {
  return this.setMultiPartUpload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.UploadData.prototype.hasMultiPartUpload = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool entity_already_exists = 4;
 * @return {boolean}
 */
proto.cloud.UploadData.prototype.getEntityAlreadyExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UploadData} returns this
 */
proto.cloud.UploadData.prototype.setEntityAlreadyExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int64 storage_location = 5;
 * @return {number}
 */
proto.cloud.UploadData.prototype.getStorageLocation = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.UploadData} returns this
 */
proto.cloud.UploadData.prototype.setStorageLocation = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.UploadResult.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.UploadResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.UploadResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UploadResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    entityId: (f = msg.getEntityId()) && general_pb.EntityId.toObject(includeInstance, f),
    completeMultiPart: (f = msg.getCompleteMultiPart()) && proto.cloud.CompleteMultiPartUpload.toObject(includeInstance, f),
    cancelMultiPart: (f = msg.getCancelMultiPart()) && proto.cloud.CancelMultiPartUpload.toObject(includeInstance, f),
    uploadError: (f = msg.getUploadError()) && general_pb.HTTPError.toObject(includeInstance, f),
    storageLocation: jspb.Message.getFieldWithDefault(msg, 5, 0),
    uploadStartDate: jspb.Message.getFieldWithDefault(msg, 6, ""),
    uploadFinishDate: jspb.Message.getFieldWithDefault(msg, 7, ""),
    uploadTotalPausedSeconds: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.UploadResult}
 */
proto.cloud.UploadResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.UploadResult;
  return proto.cloud.UploadResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.UploadResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.UploadResult}
 */
proto.cloud.UploadResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new general_pb.EntityId;
      reader.readMessage(value,general_pb.EntityId.deserializeBinaryFromReader);
      msg.setEntityId(value);
      break;
    case 2:
      var value = new proto.cloud.CompleteMultiPartUpload;
      reader.readMessage(value,proto.cloud.CompleteMultiPartUpload.deserializeBinaryFromReader);
      msg.setCompleteMultiPart(value);
      break;
    case 3:
      var value = new proto.cloud.CancelMultiPartUpload;
      reader.readMessage(value,proto.cloud.CancelMultiPartUpload.deserializeBinaryFromReader);
      msg.setCancelMultiPart(value);
      break;
    case 4:
      var value = new general_pb.HTTPError;
      reader.readMessage(value,general_pb.HTTPError.deserializeBinaryFromReader);
      msg.setUploadError(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStorageLocation(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadStartDate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUploadFinishDate(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUploadTotalPausedSeconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.UploadResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.UploadResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.UploadResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UploadResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntityId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      general_pb.EntityId.serializeBinaryToWriter
    );
  }
  f = message.getCompleteMultiPart();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.cloud.CompleteMultiPartUpload.serializeBinaryToWriter
    );
  }
  f = message.getCancelMultiPart();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.cloud.CancelMultiPartUpload.serializeBinaryToWriter
    );
  }
  f = message.getUploadError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      general_pb.HTTPError.serializeBinaryToWriter
    );
  }
  f = message.getStorageLocation();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUploadStartDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUploadFinishDate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUploadTotalPausedSeconds();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional EntityId entity_id = 1;
 * @return {?proto.cloud.EntityId}
 */
proto.cloud.UploadResult.prototype.getEntityId = function() {
  return /** @type{?proto.cloud.EntityId} */ (
    jspb.Message.getWrapperField(this, general_pb.EntityId, 1));
};


/**
 * @param {?proto.cloud.EntityId|undefined} value
 * @return {!proto.cloud.UploadResult} returns this
*/
proto.cloud.UploadResult.prototype.setEntityId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.UploadResult} returns this
 */
proto.cloud.UploadResult.prototype.clearEntityId = function() {
  return this.setEntityId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.UploadResult.prototype.hasEntityId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CompleteMultiPartUpload complete_multi_part = 2;
 * @return {?proto.cloud.CompleteMultiPartUpload}
 */
proto.cloud.UploadResult.prototype.getCompleteMultiPart = function() {
  return /** @type{?proto.cloud.CompleteMultiPartUpload} */ (
    jspb.Message.getWrapperField(this, proto.cloud.CompleteMultiPartUpload, 2));
};


/**
 * @param {?proto.cloud.CompleteMultiPartUpload|undefined} value
 * @return {!proto.cloud.UploadResult} returns this
*/
proto.cloud.UploadResult.prototype.setCompleteMultiPart = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.UploadResult} returns this
 */
proto.cloud.UploadResult.prototype.clearCompleteMultiPart = function() {
  return this.setCompleteMultiPart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.UploadResult.prototype.hasCompleteMultiPart = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CancelMultiPartUpload cancel_multi_part = 3;
 * @return {?proto.cloud.CancelMultiPartUpload}
 */
proto.cloud.UploadResult.prototype.getCancelMultiPart = function() {
  return /** @type{?proto.cloud.CancelMultiPartUpload} */ (
    jspb.Message.getWrapperField(this, proto.cloud.CancelMultiPartUpload, 3));
};


/**
 * @param {?proto.cloud.CancelMultiPartUpload|undefined} value
 * @return {!proto.cloud.UploadResult} returns this
*/
proto.cloud.UploadResult.prototype.setCancelMultiPart = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.UploadResult} returns this
 */
proto.cloud.UploadResult.prototype.clearCancelMultiPart = function() {
  return this.setCancelMultiPart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.UploadResult.prototype.hasCancelMultiPart = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional HTTPError upload_error = 4;
 * @return {?proto.cloud.HTTPError}
 */
proto.cloud.UploadResult.prototype.getUploadError = function() {
  return /** @type{?proto.cloud.HTTPError} */ (
    jspb.Message.getWrapperField(this, general_pb.HTTPError, 4));
};


/**
 * @param {?proto.cloud.HTTPError|undefined} value
 * @return {!proto.cloud.UploadResult} returns this
*/
proto.cloud.UploadResult.prototype.setUploadError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.UploadResult} returns this
 */
proto.cloud.UploadResult.prototype.clearUploadError = function() {
  return this.setUploadError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.UploadResult.prototype.hasUploadError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 storage_location = 5;
 * @return {number}
 */
proto.cloud.UploadResult.prototype.getStorageLocation = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.UploadResult} returns this
 */
proto.cloud.UploadResult.prototype.setStorageLocation = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string upload_start_date = 6;
 * @return {string}
 */
proto.cloud.UploadResult.prototype.getUploadStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UploadResult} returns this
 */
proto.cloud.UploadResult.prototype.setUploadStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string upload_finish_date = 7;
 * @return {string}
 */
proto.cloud.UploadResult.prototype.getUploadFinishDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UploadResult} returns this
 */
proto.cloud.UploadResult.prototype.setUploadFinishDate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 upload_total_paused_seconds = 8;
 * @return {number}
 */
proto.cloud.UploadResult.prototype.getUploadTotalPausedSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.UploadResult} returns this
 */
proto.cloud.UploadResult.prototype.setUploadTotalPausedSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


goog.object.extend(exports, proto.cloud);
